import { useEffect } from 'react';
import { CONTACT_EMAIL } from '../../config';
import SEOHead from '../../components/SEOHead';
import { SEO_CONFIG, getCanonicalUrl } from '../../config/seo';

function PrivacyPolicy() {
  useEffect(() => {
    document.title = 'Privacy Policy | Phoenix Unity Designs';
    const mainContent = document.querySelector('.PrivacyPolicy');
    if (mainContent) {
      mainContent.focus();
    }
  }, []);

  return (
    <>
      <SEOHead
        title={SEO_CONFIG.privacyPolicy.title}
        description={SEO_CONFIG.privacyPolicy.description}
        keywords={SEO_CONFIG.privacyPolicy.keywords}
        canonical={getCanonicalUrl(SEO_CONFIG.privacyPolicy.path)}
        ogUrl={getCanonicalUrl(SEO_CONFIG.privacyPolicy.path)}
      />
      <main id="main-content" tabIndex="-1" className='PrivacyPolicy page-container mb-5'>
      <div className='container mb-5'>
        <div className='row'>
          <div className='col'>
            <h1>Privacy Policy</h1>
            <p>Last updated: August 16 2025</p>
            <p>This website respects your privacy. We do not collect or store any personal information directly. The only data collected is through Google Analytics, which we use to understand how visitors use the site and to improve our content and services.</p>

            <h2>Google Analytics</h2>
            <p>Google Analytics collects information such as:</p>
            <ul>
              <li>Pages you visit on this site</li>
              <li>How long you spend on each page</li>
              <li>The website you came from before visiting</li>
              <li>Basic technical details (browser type, device type, general location such as city or region)</li>
            </ul>
            
            <p>This information is collected anonymously and does not identify you personally.</p>
            <p>Google may also process this data in the United States or other countries. For more information, you can read Google’s Privacy Policy.</p>
            <p>If you prefer not to be tracked by Google Analytics, you can install the Google Analytics Opt-out Browser Add-on.</p>

            <h2>Cookies</h2>
            <p>Google Analytics uses cookies to remember your interactions with this website. These cookies do not contain personal information and are used only for statistical purposes.</p>

            <h2>Contact</h2>
            <p>If you have questions about this Privacy Policy, you can contact us at: <a href={`mailto:${CONTACT_EMAIL}`}>{CONTACT_EMAIL}</a></p>
          </div>
        </div>
      </div>
    </main>
    </>
  );
}

export default PrivacyPolicy;
